enum Orientation {
    Landscape = 'landscape',
    Portrait = 'portrait'
}

export default Orientation